import { EuiButton, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFormRow } from '@elastic/eui';
import React, { useEffect, useState, useMemo } from 'react';
import { AppAdapter } from '../../../../../../infraestructure/persistence/rest/AppAdapter';
import { ComboTiposFacturacion } from '../../../../components/Selectores/TiposFacturacion/combo';
import ComboFechas from '../../../../components/Selectores/Fechas/combo';

const getFechasFacturacion = async(tipo,set) =>{
    const api = new AppAdapter();
	let result;
    try {
        result = await api.GetFechasFacturacion(tipo);
        if(result.data && result.data!=="")
        {
            set && set(([ ...result.data ] || []))
        }
    } catch (error) {
    }
}

const getTiposFacturacion = async(set) =>{
    const api = new AppAdapter();
	let result;

    try {
        result = await api.GetTiposFacturacion();
        if(result.data && result.data!=="")
        {
            set && set(([ ...result.data ] || []))
        }
    } catch (error) {
    }
}

const getDatosFacturacion = async(set) =>{
    const api = new AppAdapter();
	let result;

    try {
        result = await api.GetDatosFacturacion();
        if(result.data && result.data!=="")
        {
            set && set(([ ...result.data ] || []))
        }
    } catch (error) {
    }
}

export const HistoricoFacturacionComponent = (props) =>{

    const {onSave,showFacturacionUsu,showFacturacionProvincia} = props;
    const [fechaFacturacion, setFechaFacturacion] = useState(undefined);
    const [tipoFacturacion, setTipoFacturacion] = useState(undefined);

    const [fechas, setFechas] = useState(undefined);
    const [tipos, setTipos] = useState(undefined);

    useEffect(()=>{
        //getFechas();
        getTipos();
        //getDatos();
    },[])

    useEffect(()=>{
        tipoFacturacion!==undefined && getFechas(tipoFacturacion.idSociedadOriginal);
    },[tipoFacturacion])

    //  useEffect(()=>{
    //     tipoFacturacion!==undefined && getDescripcion(tipoFacturacion.idSociedadOriginal);
    // },[tipoFacturacion])

    // const getDatos = async()=>{
    //     await getDatosFacturacion();
    // }
    
    const getFechas = async(tipo) =>{
        await getFechasFacturacion(tipo,setFechas);
    }

    const getTipos = async() =>{
        await getTiposFacturacion(setTipos);
    }

    const onClickSave = (tipoFichero) => {onSave && onSave(tipoFichero,tipoFacturacion,fechaFacturacion);}

    const getFacturacionPorUsuario = useMemo(() =>{
        if(showFacturacionUsu === true)
        {
          return (
            <EuiFlexItem>
                <EuiButton fullWidth className='btn-download-popup' fill size='s' onClick={()=> onClickSave('FU')}>{`Facturación por Usuario`}</EuiButton>
            </EuiFlexItem>
          )
        }
      },[showFacturacionUsu,onClickSave])

      const getFacturacionPorProvincia = useMemo(() =>{
        if(showFacturacionProvincia === true)
        {
          return (
            <EuiFlexItem>
                <EuiButton fullWidth className='btn-download-popup' fill size='s' onClick={()=> onClickSave('PV')}>{`Facturación por Provincia`}</EuiButton>
            </EuiFlexItem>
          )
        }
      },[showFacturacionProvincia,onClickSave])

    //   const getGenrarHistoricos = useMemo(() =>{
    //       return (
    //         <EuiFlexItem>
    //             <EuiButton fullWidth className='btn-download-popup' color='secondary' fill size='s' onClick={()=> onClickSave('GH')}>{`Generar Historico`}</EuiButton>
    //         </EuiFlexItem>
    //       )
    //   },[onClickSave])

    return(
        <EuiFlexGroup direction='column'>
            <EuiFlexItem>
                <EuiFlexGroup>
                    <EuiFlexItem>
                        <ComboTiposFacturacion data={tipos} valueOfSelected={tipoFacturacion} onChange={value => setTipoFacturacion(value)} compressed/>
                    </EuiFlexItem>
                    <EuiFlexItem>
                        <ComboFechas fullWidth data={fechas} valueOfSelected={fechaFacturacion} onChange={value => setFechaFacturacion(value)} compressed/>
                    </EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>

            {/* <EuiFlexItem>
                <EuiFormRow
                label="Fecha Facturación (Sociedad)"
                id="ff"
                hasChildLabel={false}
                fullWidth
                >
                    <ComboFechasFacturacion fullWidth data={fechas} valueOfSelected={fechaFacturacion} onChange={value => setFechaFacturacion(value)} compressed/>
                </EuiFormRow>
            </EuiFlexItem> */}
            <EuiFlexItem>
                <EuiButton fullWidth className='btn-download-popup' fill size='s' onClick={()=> onClickSave('CP')}>{`Facturación por CP`}</EuiButton>
            </EuiFlexItem>
            <EuiFlexItem>
                <EuiButton fullWidth className='btn-download-popup' fill size='s' onClick={()=> onClickSave('FF')}>{`Facturación Final`}</EuiButton>
            </EuiFlexItem>
            {getFacturacionPorProvincia}
            {getFacturacionPorUsuario}
            {/* {getGenrarHistoricos} */}
        </EuiFlexGroup>
    )
}